import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

import { fetchData } from "../utils/fetchData";
import Project from "./Project";

const WorkList = () => {
  const [works, setWorks] = useState([]);
  const [animateCard, setanimateCard] = useState({ y: 0, opacity: 1 });
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const itemsPerPage = 3;
  const URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const workTags = async () => {
      let workData = [];
      workData = await fetchData(`${URL}/works/`);
      setWorks(workData);
    };
    workTags();
  }, [URL]);

  console.log(works);

  const totalPages = Math.ceil(works.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedData = works.slice(startIndex, endIndex);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  return (
    <>
      <motion.div
        class="app__projects"
        id="projects"
        whileInView={{ y: [100, 50, 0], opacity: [0, 0, 1] }}
        transition={{ duration: 0.5 }}
      >
        <div class="app__projects-heading">
          <div class="projects__heading-text">
            <h2 class="head-text">
              <span class="p-ctext">#</span>Projects
            </h2>
            <div class="horizontal-line"></div>
          </div>

          <div class="projects__heading-link">
            <div className="top-pagination">
              <button
                onClick={handlePrevPage}
                disabled={currentPage === 1}
                className="p-btn"
              >
                <FaArrowLeft />
              </button>

              <button
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
                className="p-btn"
              >
                <FaArrowRight />
              </button>
            </div>
          </div>
        </div>

        <div class="app__projects-container">
          {paginatedData &&
            paginatedData.map((work) => <Project work={work} />)}
        </div>
      </motion.div>
    </>
  );
};

export default WorkList;
